<template>
  <div v-if="isRouterAlive">
    <Slider
      :banner="
        `https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/news.jpg`
      "
    >
      <div class="row align-items-center">
        <div class="col  fontsiyuanmedium">
          <div class="slider-newsdetail-title fontsiyuanmedium">{{$t('slidertitle')}}</div>
          <div class="slider-newsdetail-subtitle fontsiyuanregular">
            {{$t('slidersubtitle')}}
          </div>
        </div>
      </div>
    </Slider>
    <div>
      <div class="news-detail">
        <b-container>
          <div class="newsdetail-head">
            <div class="newsdetail-title">{{$t('newsitemtitle')}}</div>
            <div>
              <span class="newsdetail-sort">{{$t('titlelist')[active]}}</span>
              <span class="newsdetail-date">{{$t('newsitemdata')}}</span>
            </div>
          </div>
          <div class="newsdetail-body" v-html="$t('newsitempage')">
          </div>
        </b-container>
      </div>
    </div>
    <div></div>
    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
export default {
  components: {
    Slider,
    Footer,
  },
  data() {
    return {
      isRouterAlive: true,
      active: 0,
      titles: ["新闻与活动", "产品资讯", "展会活动", "最新公告"],
      newslist: [],
      max: 0,

      rows: 100,
      perPage: 10,
      currentPage: 1,

      visible1:false,
      newsdetail:{}
    };
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getNews() {
      const _this = this;
      this.$store.dispatch("getNews").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
      });
    },
    getNewsItem(id){
      const _this = this;
      this.$store.dispatch("getNewsItem",{id}).then((data) => {
        console.log(data)
        let en={

          newsitemtitle:data.title_en,
          newsitempage:data.page_en,
          newsitemtype:data.type,
          newsitemdata:data.effect_at,
        }
        let zh={
          newsitemtitle:data.title,
          newsitempage:data.page,
          newsitemtype:data.type,
          newsitemdata:data.effect_at,
        }
        this.active = data.type;
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
      });

    }
  },
  mounted() {
    this.getNews();
    this.getNewsItem(this.$route.query.id)
  },
  created(){
    this.$i18n.locale=localStorage.getItem('lang')||'zh'
  },
};
</script>
<style>
.slider-newsdetail-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-newsdetail-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.news-title-group {
  text-align: center;
  z-index: 1702;
  background-color: #fff;
  border-bottom: 0.5px #bdbdbd88 solid;
}
.news-title {
  padding: 25px 0;
  cursor: pointer;
}
.news-title span {
  height: 75px;
  padding: 26px 0;
}
.news-title span:hover {
  color: #c00f31;
  font-weight: 800;
  border-bottom: 3px solid #c00f31;
}
.news-title.active span {
  border-bottom: 3px solid #c00f31;
}
.news-title.active {
  color: #c00f31;
  font-weight: 800;
}
.news-list {
  padding-bottom: 100px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.news-pagination button:hover {
  background-color: #00000000;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 30px;
  cursor: pointer;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  white-space: nowrap;
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  height: 50px;
  color: #8a8a8a;
}

.news-title-thin {
  display: none;
}
@media only screen and (max-width: 500px) {
  .news-title-wide {
    display: none;
  }
  .news-title-thin {
    display: block;
  }
  .news-title-button img {
    width: 15px;
    position: absolute;
    right: 30px;
  }
  .news-title-header {
    font-size: 15px;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px #bdbdbd44 solid;
  }
}
.newsdetail-head {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
}
.newsdetail-title {
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 20px;
}
.newsdetail-sort {
  background-color: #c00f31;
  color: #fff;
  font-size: 12px;
  padding: 2px 15px;
}
.newsdetail-date {
  margin-left: 10px;
  color: #8a8a8a;
  font-size: 12px;
}
.newsdetail-body {
  color: #8a8a8a;
  font-size: 12px;
  margin-bottom: 100px;
  text-align: center;
}
.newsdetail-body span {
  margin-top: 10px;
  margin-bottom: 20px;
  display: inline-block;
  text-align: left;
}
.newsdetail-body img {
  margin-bottom: 20px;}


.news-title-thin {
  display: none;
}
</style>